document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.video-play-button').forEach(button => {
        button.addEventListener('click', () => {
            const video = button.parentElement.querySelector('video');
            if (!video) return;
            // Hide the button
            button.style.display = 'none';
            // Show native controls
            video.setAttribute('controls', 'controls');
            // Play the video
            video.play();
        });
    });
});
